import { useQuery, useMutation } from "./urqlHooks";

const GET_EOAF = `query GetEOAF($companyId: String!, $from: String, $to: String) {
  getEOAF(companyId: $companyId, from: $from, to: $to) {
    companyId
    periods
    report {
      key
      label
      type
      values {
        fieldValue
        period
        documents
      }
      children {
        key
        label
        type
        values {
          fieldValue
          period
          documents
        }
        children {
          key
          label
          type
          values {
            fieldValue
            period
            documents
          }
          children {
            key
            label
            type
            values {
              fieldValue
              period
              documents
            }
            children {
              key
              label
              type
              values {
                fieldValue
                period
                documents
              }
            }
          }
        }
      }
    }
  }
}`;
export const GetEOAF = (variables) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_EOAF,
    variables,
    pause: !variables?.companyId,
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const EOAF_STRUCTURE = `query GET_EOAF_STRUCTURE($companyId: String!) {
    getEOAFStructure(companyId: $companyId) {
        companyId
        periods
        report {
            RECIEVED {
                field
                fieldKey
                category
                categoryKey
                rank
            }
            SPEND {
                field
                fieldKey
                category
                categoryKey
                rank
            }
        }
    }
  }`;

export const GetEOAFStructure = (variables) => {
  const [result, reexecuteQuery] = useQuery({
    query: EOAF_STRUCTURE,
    variables,
  });

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const GET_EOAF_STRUCTURE_TREE = `query GetEOAFStructureTree($companyId: String!) {
  getEOAFStructure(companyId: $companyId) {
    key
    type
    label
    children {
      key
      type
      label
      children {
        key
        type
        label
        children {
          key
          type
          label
          children {
            key
            type
            label
          }
        }
      }
    }
  }
}`;

export const GetEOAFStructureTree = (variables) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_EOAF_STRUCTURE_TREE,
    variables: variables || {},
    pause: !variables?.companyId,
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const GET_OBLIGATION_EOAF_ASSIGNMENTS = `query GetObligationEOAFAssignments($companyId: String!, $obligationId: String) {
  getObligationEOAFAssignments(companyId: $companyId, obligationId: $obligationId) {
    id
    companyId
    obligationId
    eoafArea {
      periodSince
      createdAt
      effectiveFromDate
      assignedBy {
        userId
        email
      }
      creditCategoryKey
      creditCategoryType
      creditSumOrRest
      debitCategoryKey
      debitCategoryType
      debitSumOrRest
    }
  }
}`;

export const GetObligationEOAFAssignments = (variables) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_OBLIGATION_EOAF_ASSIGNMENTS,
    variables: variables || {},
    pause: !variables?.companyId,
  });
  const { data, fetching, error } = result;
  return {
    data: data?.getObligationEOAFAssignments ?? [],
    fetching,
    error,
    reexecuteQuery,
  };
};

const SAVE_OBLIGATION_EOAF_ASSIGNMENTS_BULK = `mutation SaveObligationEOAFAssignmentsBulk($input: SaveObligationEOAFEntriesInput!, $companyId: String!) {
  saveObligationEOAFAssignmentsBulk(input: $input, companyId: $companyId) {
    id
    obligationId
    eoafArea {
      periodSince
      createdAt
      effectiveFromDate
      creditCategoryKey
      creditCategoryType
      creditSumOrRest
      debitCategoryKey
      debitCategoryType
      debitSumOrRest
    }
  }
}`;

export const SaveObligationEOAFAssignmentsBulk = () => {
  const [result, executeMutation] = useMutation(SAVE_OBLIGATION_EOAF_ASSIGNMENTS_BULK);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const GET_CONTACT_EOAF_ASSIGNMENTS = `query GetContactEOAFAssignments($companyId: String!, $contactId: String) {
  getContactEOAFAssignments(companyId: $companyId, contactId: $contactId) {
    id
    companyId
    contactId
    eoafArea {
      periodSince
      createdAt
      effectiveFromDate
      assignedBy {
        userId
        email
      }
      creditCategoryKey
      creditCategoryType
      creditSumOrRest
      debitCategoryKey
      debitCategoryType
      debitSumOrRest
    }
  }
}`;

export const GetContactEOAFAssignments = (variables) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_CONTACT_EOAF_ASSIGNMENTS,
    variables: variables || {},
    pause: !variables?.companyId,
  });
  const { data, fetching, error } = result;
  return {
    data: data?.getContactEOAFAssignments ?? [],
    fetching,
    error,
    reexecuteQuery,
  };
};

const SAVE_CONTACT_EOAF_ASSIGNMENTS_BULK = `mutation SaveContactEOAFAssignmentsBulk($input: SaveContactEOAFEntriesInput!, $companyId: String!) {
  saveContactEOAFAssignmentsBulk(input: $input, companyId: $companyId) {
    id
    contactId
    eoafArea {
      periodSince
      createdAt
      effectiveFromDate
      creditCategoryKey
      creditCategoryType
      creditSumOrRest
      debitCategoryKey
      debitCategoryType
      debitSumOrRest
    }
  }
}`;

export const SaveContactEOAFAssignmentsBulk = () => {
  const [result, executeMutation] = useMutation(SAVE_CONTACT_EOAF_ASSIGNMENTS_BULK);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const CREATE_CATEGORY_IN_EOAF = `mutation CREATE_CATEGORY_IN_EOAF(
    $companyId: String!,
    $category: String!,
    $type: EOAF_Type!,
    $areas: [CreateCategoryAreasEOAFArray!],
    $field: String,
  ) {
    createNewEOAFCategory(
      companyId: $companyId,
      category: $category,
      type: $type,
      areas: $areas,
      field: $field,
    ) {
      status,
      message,
    }
  }`;

export const CreateCategoryInEOAF = () => {
  const [result, executeMutation] = useMutation(CREATE_CATEGORY_IN_EOAF);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const CREATE_AREA_IN_EOAF = `mutation CREATE_AREA_IN_EOAF(
    $companyId: String!,
    $category: String!,
    $categoryKey: String!,
    $type: EOAF_Type!,
    $field: String!,
  ) {
    CreateNewEOAFArea(
      companyId: $companyId,
      category: $category,
      categoryKey: $categoryKey,
      type: $type,
      field: $field,
    ) {
      status,
      message,
    }
  }`;

export const CreateAreainEOAF = () => {
  const [result, executeMutation] = useMutation(CREATE_AREA_IN_EOAF);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const EDIT_CATEGORY_IN_EOAF = `mutation EDIT_CATEGORY_IN_EOAF(
    $companyId: String!,
    $newCategory: String!,
    $categoryKey: String!,
    $type: EOAF_Type!,
    $areas: [CreateCategoryAreasEOAFArray!],
  ) {
    editEOAFCategory(
      companyId: $companyId,
      newCategory: $newCategory,
      categoryKey: $categoryKey,
      type: $type,
      areas: $areas,
    ) {
      status,
      message,
    }
  }`;

export const EditCategoryinEOAF = () => {
  const [result, executeMutation] = useMutation(EDIT_CATEGORY_IN_EOAF);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const EDIT_AREA_IN_EOAF = `mutation EDIT_AREA_IN_EOAF(
  $companyId: String!,
  $fieldKey: String!,
  $newField: String!,
  $type: EOAF_Type!,
) {
  editEOAFArea(
    companyId: $companyId,
    fieldKey: $fieldKey,
    newField: $newField,
    type: $type,
  ) {
    status,
    message,
  }
}`;

export const EditAreainEOAF = () => {
  const [result, executeMutation] = useMutation(EDIT_AREA_IN_EOAF);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const DELETE_AREA_IN_EOAF = `mutation DELETE_AREA_IN_EOAF(
  $companyId: String!,
  $fieldKey: String!,
  $type: EOAF_Type!,
) {
  deleteEOAFArea(
    companyId: $companyId,
    fieldKey: $fieldKey,
    type: $type,
  ) {
    status,
    message,
  }
}`;

export const DeleteAreainEOAF = () => {
  const [result, executeMutation] = useMutation(DELETE_AREA_IN_EOAF);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const GET_EOAF_CELL_MATCHES = `query GetEOAFCellMatches($companyId: String!, $documentIds: [String!]!, $period: String!, $type: String!) {
  getEOAFCellMatches(companyId: $companyId, documentIds: $documentIds, period: $period, type: $type) {
    transactionId
    amount
  }
}`;

export const GetEOAFCellMatches = (variables) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_EOAF_CELL_MATCHES,
    variables: variables || {},
    pause: !variables?.companyId || !variables?.documentIds?.length || !variables?.period || variables?.period === 'total' || !variables?.type,
  });
  const { data, fetching, error } = result;
  return {
    data: data?.getEOAFCellMatches ?? [],
    fetching,
    error,
    reexecuteQuery,
  };
};

const UPDATE_TRANSACTION_IN_EOAF = `mutation UPDATE_TRANSACTION_IN_EOAF($input: UpdateEERRDocument!, $companyId: String!) {
  updateTransactionInEOAF(input: $input, companyId: $companyId) {
    status,
    message
  }
}`;

export const UpdateTransactionInEOAF = () => {
const [result, executeMutation] = useMutation(UPDATE_TRANSACTION_IN_EOAF);
const { data, fetching, error } = result;
return { data, fetching, error, executeMutation };
};

const RECORD_EOAF_EXCEL_EXPORT = `mutation RecordEoafExcelExport(
  $companyId: String!,
  $monthsBack: Int,
  $scope: String,
  $from: String,
  $to: String
) {
  recordEoafExcelExport(
    companyId: $companyId,
    monthsBack: $monthsBack,
    scope: $scope,
    from: $from,
    to: $to
  )
}`;

export const RecordEoafExcelExport = () => {
  const [result, executeMutation] = useMutation(RECORD_EOAF_EXCEL_EXPORT);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

// ========== STRUCTURE MANAGEMENT MUTATIONS ==========

const CREATE_NODE_EOAF = `mutation CreateNodeEOAF($companyId: String!, $input: CreateNodeInput!) {
  createNewNode(companyId: $companyId, input: $input) {
    status
    message
  }
}`;

export const CreateNodeEOAF = () => {
  const [result, executeMutation] = useMutation(CREATE_NODE_EOAF);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const EDIT_NODE_EOAF = `mutation EditNodeEOAF($companyId: String!, $input: EditNodeInput!) {
  editNode(companyId: $companyId, input: $input) {
    status
    message
  }
}`;

export const EditNodeEOAF = () => {
  const [result, executeMutation] = useMutation(EDIT_NODE_EOAF);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const DELETE_NODE_EOAF = `mutation DeleteNodeEOAF($companyId: String!, $input: DeleteNodeInput!) {
  deleteNode(companyId: $companyId, input: $input) {
    status
    message
  }
}`;

export const DeleteNodeEOAF = () => {
  const [result, executeMutation] = useMutation(DELETE_NODE_EOAF);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const MOVE_NODE_EOAF = `mutation MoveNodeEOAF($companyId: String!, $input: MoveNodeInput!) {
  moveNode(companyId: $companyId, input: $input) {
    status
    message
  }
}`;

export const MoveNodeEOAF = () => {
  const [result, executeMutation] = useMutation(MOVE_NODE_EOAF);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const REORDER_NODE_EOAF = `mutation ReorderNodeEOAF($companyId: String!, $input: ReorderNodeInput!) {
  reorderNode(companyId: $companyId, input: $input) {
    status
    message
  }
}`;

export const ReorderNodeEOAF = () => {
  const [result, executeMutation] = useMutation(REORDER_NODE_EOAF);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};
const IMPORT_EOAF_STRUCTURE = `mutation ImportEOAFStructure($companyId: String!, $sourceCompanyId: String!) {
  importEOAFStructure(companyId: $companyId, sourceCompanyId: $sourceCompanyId) {
    status
    message
  }
}`;

export const ImportEOAFStructure = () => {
  const [result, executeMutation] = useMutation(IMPORT_EOAF_STRUCTURE);
  return { ...result, executeMutation };
};
